module.exports = __webpack_public_path__ + "img/Slide19.239b02c7.png";